import React from 'react'

const Title = () => {

  return (
    <div className='text-[50px] text-bold text-white text-center'>Budget Planner 💸</div>
  )
}

export default Title